import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=db229fc2&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=db229fc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db229fc2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db229fc2')) {
      api.createRecord('db229fc2', component.options)
    } else {
      api.reload('db229fc2', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=db229fc2&scoped=true&", function () {
      api.rerender('db229fc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26JaVygs1PPNg/JS/comp/SearchFilterTokens.vue"
export default component.exports